import { api_configuration } from "../../common";
import client_state_decorator = api_configuration.types.client_state.alan_api;
import api_views = api_configuration.libraries.gui_definition_lib.types.views.alan_api;
import clock from "../state/clock";
import { getTranslation } from "./phrases";

export default function (gui_columns_binding: api_views.Cqueries): { [key: string]: client_state_decorator.Tcolumns } {
	return gui_columns_binding.properties.columns.map(function (column) {
		return {
			name: getTranslation(column.properties.name.entry), // the subscription on the selected language is handled somewhere else
			"has successor": column.properties.has_successor.switch<client_state_decorator.Tcolumns["has successor"]>({
				yes: ($) => ["yes", { successor: $.properties.successor.entry }],
				no: ["no", {}],
			}),
			"column type": column.properties.column_type.switch<client_state_decorator.Tcolumns["column type"]>({
				id: ["id", {}],
				content: ["content", {}],
			}),
			type: column.properties.type.switch<client_state_decorator.Tcolumns["type"]>({
				text: function (text) {
					return [
						"text",
						{
							"has filter": text.properties.filter.switch<client_state_decorator.Ttext__type__columns["has filter"]>({
								none: ["no", {}],
								simple: function (yes__has_filter) {
									const criteria = yes__has_filter.properties.criteria;
									return [
										"yes",
										{
											"filter set": criteria.length > 0 ? ["yes", {}] : ["no", {}],
											"has default filter": ["yes", {}],
											value: criteria,
											operation: ["equals", {}],
										},
									];
								},
								"current id path": ["no", {}], //TODO remove when filters are supported in the generator
							}),
							"filter on current id path": text.properties.filter.switch({
								"current id path": ["yes", {}],
								none: ["no", {}],
								simple: ["no", {}],
							}),
						},
					];
				},
				file: ["file", {}],
				number: function (value) {
					return [
						"number",
						{
							"has filter": value.properties.has_filter.switch<
								client_state_decorator.Tnumber__type__columns["has filter"]
							>({
								no: ["no", {}],
								yes: function (yes__has_filter) {
									return [
										"yes",
										{
											"operator selected": yes__has_filter.properties.operator_selected.switch<
												client_state_decorator.Tyes__has_filter__number["operator selected"]
											>({
												yes: function ($) {
													return [
														"yes",
														{
															operator: $.properties.operator.switch<
																client_state_decorator.Tyes__operator_selected["operator"]
															>({
																"equal to": ["equal to", {}],
																"greater than": ["greater than", {}],
																"greater than or equal to": ["greater than or equal to", {}],
																"smaller than": ["smaller than", {}],
																"smaller than or equal to": ["smaller than or equal to", {}],
															}),
														},
													];
												},
												no: ["no", {}],
											}),
											"criteria is valid": yes__has_filter.properties.initial_criteria.switch<
												client_state_decorator.Tyes__has_filter__number["criteria is valid"]
											>({
												none: ["no", {}],
												yes: function (yes__initial_criteria) {
													return [
														"yes",
														{
															criteria: yes__initial_criteria.properties.source.switch({
																now: function (now__source) {
																	return (
																		clock.getNow() +
																		now__source.properties.has_offset.switch({
																			none: 0,
																			yes: function (yes__has_offset) {
																				return yes__has_offset.properties.offset.value;
																			},
																		})
																	);
																},
																static: function (static__source) {
																	return static__source.properties.number.value;
																},
															}),
														},
													];
												},
											}),
											"filter range": "no",
											"has default filter": ["yes", {}],
											"filter set": yes__has_filter.properties.initial_criteria.switch({
												none: ["no", {}],
												yes: ["yes", {}],
											}),
											"numerical type properties": {
												initialized: ["no", {}],
											},
										},
									];
								},
							}),
						},
					];
				},
				"state group": function (state_group) {
					return [
						"state group",
						{
							"has filter": state_group.properties.has_filter.switch<
								client_state_decorator.Tstate_group__type__columns["has filter"]
							>({
								no: ["no", {}],
								yes: function (yes__has_filter) {
									return [
										"yes",
										{
											"filter enabled": yes__has_filter.properties.filter_enabled.switch<
												client_state_decorator.Tyes__has_filter__state_group["filter enabled"]
											>({
												yes: ["yes", {}],
												no: ["no", {}],
											}),
											"has default filter": ["yes", {}],
											states: yes__has_filter.properties.states.map(function (state) {
												return {
													name: getTranslation(state.key.entry),
													"is selected": state.properties.is_selected.switch<
														client_state_decorator.Tstates__yes["is selected"]
													>({
														no: ["no", {}],
														yes: ["yes", {}],
													}),
												};
											}),
										},
									];
								},
							}),
						},
					];
				},
				widget: (): client_state_decorator.Tcolumns["type"] => ["widget", {}],
			}),
		};
	});
}
